module.exports = __webpack_public_path__ + "img/20170319-1.d4b74c8a.jpeg";